import type { IUser } from '../../../models/pa-egna-ben/user.model';

export class TeacherApiModel {
  public phoneNumber!: string;
  public emailAddress!: string;
  public firstName!: string;
  public lastName!: string;

  public static mapToBusinessModel(apiModel: TeacherApiModel): IUser {
    return {
      id: -1,
      phoneNumber: apiModel.phoneNumber,
      emailAddress: apiModel.emailAddress,
      firstName: apiModel.firstName,
      lastName: apiModel.lastName,
    };
  }
}

